import { render, staticRenderFns } from "./outer.vue?vue&type=template&id=ec636dc2&scoped=true&"
import script from "./outer.vue?vue&type=script&lang=js&"
export * from "./outer.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/outer.scss?vue&type=style&index=1&id=ec636dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec636dc2",
  null
  
)

export default component.exports